<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hgf0fs/tc-custom/9781504098823.jpg?1728169120212" alt="This image is the cover for the book Anagramist, Feyer and Drake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anagramist, Feyer and Drake
      </h1>
      <p class="bookDescription body article font2">
        <b>A damaged woman. A tormented man. Can they work together to stop a cold-blooded killer? </b><br/><br/> DCI Samantha Feyer has been abused and ostracized by her former colleagues. Meanwhile, Wes Drake is tortured by cryptic emails relating to a series of violent murders.<br/><br/> Drawn together by circumstance, Feyer and Drake are soon tasked with tracking down an enigmatic murderer who callously slaughters his victims.<br/><br/> Can Drake’s methodical mind, coupled with Feyer’s unflinching investigative skills, unmask the killer and bring him to justice?<br/><br/> As they are drawn deeper into a nightmare journey of personal suffering, it’s unclear who, if anyone, might make it out alive . . .<br/><br/> “A very good read. The right balance of crime and human interest.” <i>—</i>Maureen Vincent-Northam, author of <i>Black Dog’s Treasure</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David W Robinson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?371a6d44